import React, { ComponentProps } from 'react';

import SubtleLink from '../subtleLink/SubtleLink';

import { ReactComponent as ExternalIcon } from './external.svg';
import styles from './ExternalLink.module.css';

type Props = Omit<ComponentProps<'a'>, 'target'> & {
  noIcon?: boolean;
};

const baseRel = 'external noreferrer';

export default function ExternalLink({ children, noIcon, rel, ...props }: Props) {
  return (
    <SubtleLink target="_blank" rel={rel ? `${baseRel} ${rel}` : baseRel} {...props}>
      {children}
      {!noIcon && (
        <span className={styles.IconWrapper}>
          <ExternalIcon className={styles.Icon} />
        </span>
      )}
    </SubtleLink>
  );
}
